import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    /** The text that displays within the Availability Tag */
    availabilityStatus: PropTypes.oneOf([ 'Available', 'First-come, First-served', 'Lottery', 'Partially Available', 'Unavailable', 'New', 'Enter Date', 'Enter Dates']),

    /** ClassName for the Availability Tag */
    availabilityClass: PropTypes.string,

    /** Does the Availability Tag overlay an image */
    isImageOverlay: PropTypes.bool,
};

const defaultProps = {
    isImageOverlay: true,
}

export default class BaseAvailabilityTag extends React.Component {
    render() {
        const {
            availabilityStatus,
            availabilityClass,
            isImageOverlay
        } = this.props;

        const tagOverlaysImage = isImageOverlay ? '' : 'not-image-overlay'

        return (
                <span
                    className={`${availabilityClass} ${tagOverlaysImage}`}
                    key={availabilityStatus}>
                        {availabilityStatus}
                </span>
            );
        }
    }

BaseAvailabilityTag.propTypes = propTypes;
BaseAvailabilityTag.defaultProps = defaultProps;